/**
 * Multi-sample anti-aliasing samples.
 */
export enum MSAASamples {
  /** No multi-sample anti-aliasing. */
  None = 1,
  /** Multi-sample anti-aliasing with 2 samples. */
  TwoX = 2,
  /** Multi-sample anti-aliasing with 4 samples. */
  FourX = 4,
  /** Multi-sample anti-aliasing with 8 samples. */
  EightX = 8
}
